import React, { useState } from 'react';
import { Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { TfiCheck } from 'react-icons/tfi';
import TableCollapse from '../tableCollapse';

function VpsPlanColumns() {
    const { t } = useTranslation();
    const [openSections, setOpenSections] = useState({});

    const toggleCollapse = (id) => {
        setOpenSections((prevSections) => ({
            ...prevSections,
            [id]: !prevSections[id]
        }));
    };
    const green = '#00af60';

    return (
        <Row>
            <table width="100%" className="extended-plan-table" id="extended-plan-table">
                <tbody className="card-header">
                    <tr>
                        <th colSpan="5" className="sub-heading">
                            {t('vps-page.ext-plans-column.table-1.title')}
                        </th>
                    </tr>
                </tbody>
                <tbody>
                    <tr>
                        <th>{t('vps-page.ext-plans-column.table-1.property-1')}</th>
                        <td>{t('vps-page.ext-plans-column.table-1.value-1')}</td>
                    </tr>
                    <tr>
                        <th>{t('vps-page.ext-plans-column.table-1.property-2')}</th>
                        <td>{t('vps-page.ext-plans-column.table-1.value-2')}</td>
                    </tr>
                    <tr>
                        <th>{t('vps-page.ext-plans-column.table-1.property-3')}</th>
                        <td>
                            {' '}
                            <TfiCheck color={green} />
                        </td>
                    </tr>
                    <tr>
                        <th>{t('vps-page.ext-plans-column.table-1.property-4')}</th>
                        <td>
                            {' '}
                            <TfiCheck color={green} />
                        </td>
                    </tr>
                    <tr>
                        <th>{t('vps-page.ext-plans-column.table-1.property-5')}</th>
                        <td>{t('titles.unlimited')}</td>
                    </tr>
                    <tr>
                        <th>{t('vps-page.ext-plans-column.table-1.property-6')}</th>
                        <td>
                            {' '}
                            <TfiCheck color={green} />
                        </td>
                    </tr>
                    <tr>
                        <th>{t('vps-page.ext-plans-column.table-1.property-7')}</th>
                        <td>
                            {' '}
                            <TfiCheck color={green} />
                        </td>
                    </tr>
                    <tr>
                        <th>{t('vps-page.ext-plans-column.table-1.property-8')}</th>
                        <td>
                            cPanel, Plesk, Interworks, ISPConfig3, Webuzo, Webmin, VestaCP, CWP...
                        </td>
                    </tr>
                </tbody>
            </table>
            <div className="table-wrapper">
                <TableCollapse
                    isOpen={!!openSections.section1}
                    toggle={toggleCollapse}
                    id="section1"
                    title={t('vps-page.ext-plans-column.table-2.title')}
                >
                    <table className="pricing-table">
                        <tbody>
                            <tr>
                                <th>{t('vps-page.ext-plans-column.table-2.property-1')}</th>
                                <td>{t('vps-page.ext-plans-column.table-2.value-1')}</td>
                            </tr>
                            <tr>
                                <th>{t('vps-page.ext-plans-column.table-2.property-2')}</th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>{t('vps-page.ext-plans-column.table-2.property-3')}</th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>{t('vps-page.ext-plans-column.table-2.property-4')}</th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>{t('vps-page.ext-plans-column.table-2.property-5')}</th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </TableCollapse>
            </div>
            <div className="table-wrapper">
                <TableCollapse
                    isOpen={!!openSections.section2}
                    toggle={toggleCollapse}
                    id="section2"
                    title={t('vps-page.ext-plans-column.table-3.title')}
                >
                    <table className="pricing-table">
                        <tbody>
                            <tr>
                                <th>{t('vps-page.ext-plans-column.table-3.property-1')}</th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>{t('vps-page.ext-plans-column.table-3.property-2')}</th>
                                <td>{t('titles.unlimited')}</td>
                            </tr>
                            <tr>
                                <th>{t('vps-page.ext-plans-column.table-3.property-3')}</th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>{t('vps-page.ext-plans-column.table-3.property-4')}</th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>{t('vps-page.ext-plans-column.table-3.property-5')}</th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>{t('vps-page.ext-plans-column.table-3.property-6')}</th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>{t('vps-page.ext-plans-column.table-3.property-7')}</th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>{t('vps-page.ext-plans-column.table-3.property-8')}</th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>{t('vps-page.ext-plans-column.table-3.property-9')}</th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>{t('vps-page.ext-plans-column.table-3.property-10')}</th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </TableCollapse>
            </div>
            <div className="table-wrapper">
                <TableCollapse
                    isOpen={!!openSections.section3}
                    toggle={toggleCollapse}
                    id="section3"
                    title={t('vps-page.ext-plans-column.table-4.title')}
                >
                    <table className="pricing-table">
                        <tbody>
                            <tr>
                                <th>{t('vps-page.ext-plans-column.table-4.property-1')}</th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>{t('vps-page.ext-plans-column.table-4.property-2')}</th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>{t('vps-page.ext-plans-column.table-4.property-3')}</th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>{t('vps-page.ext-plans-column.table-4.property-4')}</th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>{t('vps-page.ext-plans-column.table-4.property-5')}</th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </TableCollapse>
            </div>
        </Row>
    );
}

export default VpsPlanColumns;
